import React from 'react'
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import clsx from 'clsx';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyle = makeStyles(theme => ({
    column: {
        width: '100%'
    },
    flexGrow: {
        flexGrow: 1
    }
}));

function GridBlock(
    {
        direction,
        className,
        itemClassName,
        children,
        alignItems,
        spacing,
        justify,
        wrap,
        column = false,
        onClick,
        flexGrow = false,
        gridClasses,
        id
    }) {

    const classes = useStyle();
    return (
        <Grid
            container
            className={className}
            direction={column ? 'column' : direction}
            alignItems={alignItems}
            spacing={spacing}
            justifyContent={justify}
            wrap={wrap}
            onClick={onClick}
            classes={gridClasses}
            id={id}
        >
            {React.Children.map(children, child => {
                    return child &&
                        <Grid
                            item
                            classes={gridClasses}
                            className={clsx(itemClassName, {
                                [classes.column]: column,
                                [classes.flexGrow]: flexGrow,
                            })}
                        >
                            {child}
                        </Grid>

                }
            )}
        </Grid>
    )
}

GridBlock.propTypes = {
    className: PropTypes.string,
}

GridBlock.defaultProps = {}

export default GridBlock;